import React from 'react'
import { FieldErrors } from 'react-hook-form'

import { ErrorMessage } from '@hookform/error-message'
import type { TFunction } from 'i18next'

import { FormFieldValidationText } from './FormFieldValidationText'

interface FormFieldErrorProps {
  t?: TFunction<any>
  name: string
  errors?: FieldErrors<any>
  warnings?: Record<string, any>
}

// NOTE: memo cannot be used here because react-hook-form mutate errors object
export const FormFieldValidation = ({
  t,
  name,
  errors,
  warnings,
}: FormFieldErrorProps) => {
  const variant = (() => {
    if (errors) {
      return 'danger'
    }
    if (warnings) {
      return 'warning'
    }
    return 'default'
  })()

  return (
    <ErrorMessage
      {...{
        errors: errors ?? warnings,
        name,
        render: ({ message }: { message: string }) =>
          message ? (
            <FormFieldValidationText {...{ variant }}>
              {typeof t === 'function'
                ? t(message.toString() as any)
                : message.toString()}
            </FormFieldValidationText>
          ) : null,
      }}
    />
  )
}
